<template>
  <el-row class="footer_box">
    <el-col class="top_img">
      <img style="width:100%;height: 120px;" src="../assets/images/home/gxxm.png" alt="" />
      <div class="btn_box">公司项目</div>
    </el-col>

    <el-col class="foot_list">
      <!-- 移动端走马灯 -->
      <el-carousel 
        v-if="isMobile"
        :interval="5000" 
        indicator-position="outside" 
        height="300px"
        class="mobile-carousel"
      >
        <el-carousel-item v-for="(item, index) in gsxmArr" :key="index">
          <div class="mobile-item">
            <img v-if="item.icon" class="top_imgs" :src="item.icon" alt="" />
            <span style="margin-top: 10px;">{{ item.title }}</span>
            <div class="btn_text" @click="navDateils(item)">
              点击查看
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>

      <!-- PC端样式 -->
      <div v-else class="list_box flex_start_start flex_wrap">
        <div class="list_item" v-for="(item, index) in gsxmArr" :key="index">
          <img v-if="item.icon" class="top_imgs" :src="item.icon" alt="" />
          <span style="margin-top: 10px;">{{ item.title }}</span>
          <div class="btn_text" @click="navDateils(item)">
            点击查看
          </div>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script setup>
import http from "@/utils/api";
import {
  ref,
  watch,
  onBeforeMount,
  toRaw,
  computed,
  onMounted,
  onBeforeUnmount
} from "vue";
import router from "@/router";
import { useStore } from 'vuex';

const store = useStore();
const props = defineProps({
  companyNub: {
    type: Number,
    default: 1,
  },
});

// 响应式判断是否为移动端
const isMobile = ref(false);
const gsxmArr = ref([]);
const retryTimer = ref(null); // 重试定时器

const checkIsMobile = () => {
  isMobile.value = window.innerWidth < 768;
};

//公司项目
const getGsxm = async () => {
  try {
    let res = await http.base.NewsQuery({
      page: 1,
      limit: 8,
      orgId: '',
      date: "",
      select: "type,url,createDate,content,title,secTitle,icon,id",
      where: `type like '%ccGsxm%'`,
      sortby: "sort desc",
    });
    
    if (res && res.code == 0) {
      gsxmArr.value = res.data.data || [];

      if (gsxmArr.value.length) {
        gsxmArr.value.forEach((item) => {
          item["imgObj"] = extractMediaPaths(item.url);
        });
      }
    }
  } catch (error) {
    console.error("获取公司项目失败:", error);
    // 登录失败时3秒后重试
    if (retryTimer.value) clearTimeout(retryTimer.value);
    retryTimer.value = setTimeout(() => {
      if (store.state.isLoggedIn) {
        getGsxm();
      }
    }, 3000);
  }
};

const extractMediaPaths = (inputString) => {
  if (!inputString) return "";
  const paths = inputString.split(",");
  let imagePath = [];
  let otherPaths = [];

  const imageRegex = /\.(jpeg|jpg|png|gif|bmp)$/i;

  for (let path of paths) {
    path = path.trim();

    if (imageRegex.test(path)) {
      imagePath.push(path);
    } else {
      otherPaths.push(path);
    }
  }

  return {
    imagePath: imagePath,
    otherPaths: otherPaths,
  };
};

// 确定文件类型
const determineFileType = (url) => {
  if (!url) return;
  const extension = url.split(".").pop().toLowerCase();
  switch (extension) {
    case "jpeg":
    case "jpg":
    case "png":
    case "gif":
    case "bmp":
      return "图片";
    case "mp4":
    case "avi":
    case "mov":
    case "mkv":
    case "webm":
      return "视频";
    case "pdf":
      return "PDF";
    default:
      return "未知类型";
  }
};

const navDateils = (item) => {
  const { id, url } = item;
  const routeParams = {
    path: "",
    query: { id }
  };

  if (url) {
    const fileType = determineFileType(url);
    if (fileType === "PDF" || fileType === "视频") {
      routeParams.path = "/fileDetails";
    } else {
      routeParams.path = "/listDetails";
    }
  } else {
    routeParams.path = "/listDetails";
  }
  router.push(routeParams);
};

// 监听登录状态变化
watch(() => store.state.isLoggedIn, (newVal) => {
  if (newVal) {
    getGsxm();
  }
});

// 监听props变化
watch(
  () => props.companyNub,
  () => {
    if (store.state.isLoggedIn) {
      getGsxm();
    }
  },
  { immediate: true }
);

onMounted(() => {
  checkIsMobile();
  window.addEventListener('resize', checkIsMobile);
  
  // 初始加载时检查登录状态
  if (store.state.isLoggedIn) {
    getGsxm();
  }
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', checkIsMobile);
  if (retryTimer.value) {
    clearTimeout(retryTimer.value);
  }
});
</script>

<style scoped lang="scss">
.footer_box {
  margin-bottom: 20px;
  padding-top: 20px;
  position: relative;
  background-color: #f2f2f2;

  .foot_list {
    width: 100%;
    
    /* PC端样式 */
    .list_box {
      width: 100%;
      height: 100%;
      margin-left: -10px;

      .list_item {
        width: calc(25% - 34px);
        display: flex;
        flex-direction: column;
        align-items: center;
        background-color: #fff !important;
        transition: all 0.35s ease;
        font-size: 14px;
        box-shadow: 0 5px 10px rgba(0, 0, 0, 0.175) !important;
        margin: 0px 19px 38px 19px;
        padding-bottom: 12px;

        .top_imgs {
          width: 100%;
          height: 164px;
          object-fit: cover;
        }

        .btn_text {
          width: 80px;
          height: 24px;
          background-color: #c0a55c;
          border-radius: 10px;
          font-size: 14px;
          color: white;
          text-align: center;
          margin-top: 20px;
          cursor: pointer;
        }
      }

      .list_item:nth-child(4n) {
        margin-right: 0px;
      }
    }

    /* 移动端走马灯样式 */
    .mobile-carousel {
      width: 100%;
      margin: 0 auto;
      
      .mobile-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        background-color: #fff;
        margin: 0 15px;
        padding: 15px;
        box-shadow: 0 5px 10px rgba(0, 0, 0, 0.175);
        height: 280px;
        
        .top_imgs {
          width: 100%;
          height: 180px;
          object-fit: cover;
          margin-bottom: 10px;
        }
        
        .btn_text {
          width: 80px;
          height: 24px;
          background-color: #c0a55c;
          border-radius: 10px;
          font-size: 14px;
          color: white;
          text-align: center;
          margin-top: 15px;
          cursor: pointer;
        }
      }
    }
  }

  .btn_box {
    padding: 10px 24px;
    position: absolute;
    top: 130px;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 20px;
    background-color: rgb(192, 165, 92);
    font-weight: bold;
    color: white;
  }

  .top_img {
    width: 100%;
    height: 100px;
    margin-bottom: 50px;
    display: flex;
    justify-content: cneter;

    .imgs {
      width: 600px;
      height: 100%;
    }
  }
}

/* 响应式调整 */
@media (max-width: 768px) {
  .footer_box {
    .foot_list {
      .list_box {
        width: 100%;
        margin-left: 0;
        
        .list_item {
          width: calc(50% - 20px);
          margin: 0 10px 20px;
        }
      }
    }
  }
}

/* 自定义指示器样式 */
:deep(.el-carousel__indicator) {
  padding: 12px 4px;
}

:deep(.el-carousel__button) {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #c0a55c;
}
</style>